var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Modal as MuiModal } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { useMemo } from 'react';
import { useBoolean } from 'react-use';
import { styled } from '@mui/system';
var DefaultConfirmAction = function (props) { return (_jsx(Button, __assign({}, props, { fullWidth: true, variant: "contained" }, { children: "OK" }))); };
export var Modal = function (_a) {
    var open = _a.open, onClose = _a.onClose, children = _a.children, modalStyle = _a.modalStyle, _b = _a.ConfirmAction, ConfirmAction = _b === void 0 ? DefaultConfirmAction : _b, CancelAction = _a.CancelAction;
    var _c = useBoolean(true), visible = _c[0], setVisible = _c[1];
    var handleClose = function () {
        setVisible(false);
        setTimeout(function () {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }, 250);
        setTimeout(function () {
            setVisible(true);
        }, 500);
    };
    var ConfirmActionMemo = useMemo(function () { return ConfirmAction; }, []);
    var CancelActionMemo = useMemo(function () { return CancelAction; }, []);
    return (_jsx(MuiModal, __assign({ open: open }, { children: _jsx(_Fragment, { children: _jsx(AnimatePresence, { children: visible && (_jsxs(MotionModalWrapper, __assign({ style: modalStyle, initial: { scale: 0, x: '-50%', y: '0%' }, animate: { scale: 1, x: '-50%', y: '-50%' }, exit: { scale: 0, x: '-50%', y: '0%' } }, { children: [children, _jsxs("div", __assign({ className: "grid md:mx-auto gap-4 ".concat(CancelAction ? 'md:grid-cols-2' : '') }, { children: [CancelActionMemo && _jsx(CancelActionMemo, { onClick: handleClose }), _jsx(ConfirmActionMemo, { onClick: handleClose })] }))] }), "modal")) }) }) })));
};
export default Modal;
var ModalWrapper = styled('div')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    maxWidth: '500px',
    backgroundColor: 'white',
    borderRadius: '1rem',
    padding: '2rem',
    maxHeight: 'calc(100vh - 4rem)',
    gap: '2rem',
    overflow: 'auto',
    display: 'grid',
});
var MotionModalWrapper = motion(ModalWrapper);
